/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {Reducer} from 'redux';

import {IRoom} from 'interfaces';
import {
  ROOMS_FETCHING_DONE,
  ROOMS_FETCHING_ERROR,
  ROOMS_FETCHING,
  ROOMS_REMOVE,
  SET_ROOM_TYPE,
  RoomsActions
} from 'store/action/rooms';
import {IPortalError} from 'utility/error-handler';

export interface IRoomsState {
  roomList: IRoom[];
  roomType: {
    label: string;
    value: string;
  };
  isFetching: boolean;
  error: null | IPortalError;
}

const initialRoomState = {
  roomList: [],
  roomType: {
    label: 'Multi Party Chat',
    value: 'MultiPartyChat'
  },
  isFetching: false,
  error: null
};
const roomReducer: Reducer<Readonly<IRoomsState>, RoomsActions> = (
  state: IRoomsState = initialRoomState,
  action: RoomsActions
) => {
  switch (action.type) {
    case ROOMS_FETCHING:
      return {
        ...state,
        error: null,
        isFetching: true
      };
    case ROOMS_FETCHING_DONE:
      return {
        ...state,
        roomList: action.payload,
        error: null,
        isFetching: false
      };
    case ROOMS_FETCHING_ERROR:
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    case ROOMS_REMOVE:
      return {
        ...state,
        roomList: state.roomList.filter(rooms => rooms.roomId !== action.roomId)
      };
    case SET_ROOM_TYPE:
      return {
        ...state,
        roomType: action.roomType
      };
    default:
      return state;
  }
};

export default roomReducer;